import { Component, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { EventType, getEmptyEventType } from 'src/app/interfaces/event-type';
import { AuthService } from 'src/app/services/auth.service';
import { EmailListService } from 'src/app/services/emaillist.service';
import { EventtypeService } from 'src/app/services/eventtype.service';
import { ToastService } from 'src/app/services/toast.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-eventtypelist',
  templateUrl: './eventtypelist.component.html',
  styleUrls: ['./eventtypelist.component.scss'],
})
export class EventtypelistComponent implements OnInit {
  mailing_lists: any[];
  eventtypes: any[] = [];
  companyid: any;
  event: any;
  eventtypesLocal: any[];
  currentEventTypeId: any;
  loading: boolean = false;
  token: any;

  constructor(
    private storage: Storage,
    private eventTypeService: EventtypeService,
    private alertController: AlertController,
    private toastS: ToastService,
    private authService: AuthService
  ) {
    this.eventTypeService.eventtypeSave.subscribe(x => {
      this.foundIndex(x);
      console.log("eventtypesave ", x);
      this.eventTypeService.getAllEventtypes(this.companyid).subscribe(x => {
        this.eventtypes = x;
        this.storage.set(environment.storage.eventtype, this.eventtypes);
        console.log('getAllEventtypes: ', x);
        this.loading = false;
        // this.addNewEventTypes();
      });
      // this.addNewEventTypes();
    })
  }

  async ngOnInit() {
    this.token = await this.authService.getDecodedUserToken();
    this.companyid = this.token.company;
    this.loading = true;
    this.eventTypeService.getAllEventtypes(this.companyid).subscribe(x => {
      this.eventtypes = x;
      this.storage.set(environment.storage.eventtype, this.eventtypes);
      console.log('getAllEventtypes: ', x);
      this.loading = false;
      // this.addNewEventTypes();
    });
  }

  ionViewWillEnter() {
  }

  async openEventType(eventtype) {//edit
    this.foundIndex(eventtype);
    this.eventTypeService.eventtypeDataSubject.next(eventtype);//new Subjekt Ermitter
  }

  checkTime(minDuration) {
    const d = Math.floor(minDuration * 60 / (3600 * 24));
    const h = Math.floor(minDuration * 60 % (3600 * 24) / 3600);
    const m = Math.floor(minDuration * 60 % 3600 / 60);
    if (d > 0) {
      if (d === 1) {
        return d + " Tag " + h + " Stunden " + m + " Minuten"
      }
      else {
        return d + " Tage " + h + " Stunden " + m + " Minuten"
      }

    }
    else {
      if (h > 0) {
        if (h === 1 && m > 0) {
          return h + " Stunde " + m + " Minuten"
        }
        if (h === 1 && m == 0) {
          return h + " Stunde "
        }
        else {
          if (m > 0) {
            return h + " Stunden " + m + " Minuten"
          }
          else {
            return h + " Stunden "
          }
        }
      }
      else {
        return m + " Minuten"
      }


    }
  }

  foundIndex(eventtype) {
    // Element mit leerer id wird entfernt
    let emptyElementIndex = this.eventtypes.findIndex(element => element._id === undefined);
    if (emptyElementIndex > -1) {
      this.eventtypes.splice(emptyElementIndex, 1);
    }

    let index = this.eventtypes.findIndex(y => y._id === (eventtype as EventType)._id);
    this.currentEventTypeId = (eventtype as EventType)?._id;
    if (index != -1) {
      // wird local überschrieben
      this.eventtypes[index] = eventtype;
    } else {
      //wird local hinzufügt
      this.eventtypes.unshift(eventtype);
    }
  }

  addNewEventTypes() {
    let eventtype = getEmptyEventType();
    eventtype.company = this.companyid;
    this.foundIndex(eventtype);
    this.eventTypeService.eventtypeDataSubject.next(eventtype);
  }

  async delete(eventid, index) {
    const alert = await this.alertController.create({
      header: 'LÖSCHEN',
      message: 'Möchtest du wirklich löschen?',
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel'
        },
        {
          text: 'OK',
          role: 'ok',
          handler: () => {
            this.eventTypeService.deleteEventtype(eventid._id).subscribe(x => {
              console.log("Löschen funktioniert", x);
              // local löschen
              this.eventtypes.splice(index, 1);

              this.toastS.deleteToast();
            }, err => {
              console.log("Löschen funktioniert NICHT", err);
              this.toastS.deleteToastNot();
            })
          }
        }
      ]
    });
    alert.present();
  }
}
